import { EAccessMenu } from "@/graphql/types";
import { getPermissions } from "@/utils/activity";

export const useExpensePermissions = () => {
  return getPermissions(EAccessMenu.Expense);
};
